module.exports = __webpack_public_path__ + "img/startStreaming.0fdb5814.png";